import React, { useEffect, useMemo, useState } from 'react';
import {
  getFacturationItemsPerPage,
  DEFAULT_FACTURATION_CONFIG,
} from './facturationConfigDefaults';
import {
  facturationPagedSlice,
  resolveFacturationPageSize,
} from './utils/facturationTablePageSize';
import { useFacturationConfig } from './useFacturationConfig';

export { getFacturationItemsPerPage, DEFAULT_FACTURATION_CONFIG, resolveFacturationPageSize };

/** Sync table/cards toggle with facturation config defaultView (real-time). */
export function useFacturationListViewMode(facturationConfig) {
  const [viewMode, setViewMode] = useState(() => facturationConfig?.defaultView || 'table');

  useEffect(() => {
    setViewMode(facturationConfig?.defaultView || 'table');
  }, [facturationConfig?.defaultView]);

  return [viewMode, setViewMode];
}

/** Paginate a filtered list using module itemsPerPage (real-time). */
export function useFacturationListPagination(filteredItems) {
  const facturationConfig = useFacturationConfig();
  const pageSize = resolveFacturationPageSize(facturationConfig);
  const [listPage, setListPage] = useState(1);

  useEffect(() => {
    setListPage(1);
  }, [filteredItems, pageSize]);

  const totalItems = Array.isArray(filteredItems) ? filteredItems.length : 0;
  const pagedItems = useMemo(
    () => facturationPagedSlice(filteredItems, listPage, pageSize),
    [filteredItems, listPage, pageSize],
  );

  return {
    facturationConfig,
    pageSize,
    listPage,
    setListPage,
    pagedItems,
    totalItems,
  };
}

/** Shown when a billing submodule is turned off in إعدادات الفوترة. */
export function FacturationConfigNotice({ message }) {
  if (!message) return null;
  return (
    <div className="mb-4 rounded-2xl border border-amber-500/35 bg-amber-500/12 px-4 py-3 text-amber-100 text-sm text-right leading-relaxed">
      {message}
    </div>
  );
}
